module.exports = __webpack_public_path__ + "media/video403.cd8980ef.mp4";